import React from 'react';
import { useTranslation } from 'react-i18next';
import './CEFRGuideModal.css';

const CEFR_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'] as const;

interface CEFRGuideModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CEFRGuideModal: React.FC<CEFRGuideModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('cefrGuide');

  if (!isOpen) return null;

  const renderCell = (value: string) => {
    if (value === '—' || value === '') {
      return <span className="cefr-guide-dash">—</span>;
    }
    return value;
  };

  return (
    <div className="cefr-guide-overlay" onClick={onClose}>
      <div className="cefr-guide-modal" onClick={(e) => e.stopPropagation()}>
        <button className="cefr-guide-close" onClick={onClose}>
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <h2>{t('title')}</h2>
        <p className="cefr-guide-intro">{t('intro')}</p>

        <table className="cefr-guide-table">
          <thead>
            <tr>
              <th>{t('tableHeaders.level')}</th>
              <th>{t('tableHeaders.domestic')}</th>
              <th>{t('tableHeaders.school')}</th>
              <th>{t('tableHeaders.toeic')}</th>
              <th>{t('tableHeaders.ielts')}</th>
            </tr>
          </thead>
          <tbody>
            {CEFR_LEVELS.map((level) => (
              <tr key={level}>
                <td>
                  <div className="cefr-guide-level-cell">
                    <span className={`cefr-guide-badge cefr-guide-badge--${level}`}>{level}</span>
                    <span className="cefr-guide-level-name">{t(`levels.${level}.name`)}</span>
                  </div>
                </td>
                <td>{renderCell(t(`levels.${level}.domestic`))}</td>
                <td>{renderCell(t(`levels.${level}.school`))}</td>
                <td>{renderCell(t(`levels.${level}.toeic`))}</td>
                <td>{renderCell(t(`levels.${level}.ielts`))}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
